import React from "react";
import blocks from "../../blocks";

export default ({block, page, quantityBlocks, settings}) => {
    const BlockComponent = blocks[block?.template] || blocks.default;

    return <BlockComponent block={block} page={page} quantityBlocks={quantityBlocks} settings={settings} />
}
